(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cats-pyjamas-shrinkage-warning"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const safeJsonParse = (value) => {
      try {
        const parsed = JSON.parse(value || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const buildChart = (mount) => {
      if (mount.dataset.chartReady === 'true') return;

      const columns = safeJsonParse(mount.dataset.columns);
      const rows = safeJsonParse(mount.dataset.rows);
      if (columns.length < 2 || rows.length === 0) return;

      const scroll = document.createElement('div');
      scroll.className = 'cats-pyjamas-warning__table-scroll';
      scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-labelledby', mount.closest('[role="tabpanel"]').getAttribute('aria-labelledby'));

      const table = document.createElement('table');
      table.className = 'cats-pyjamas-warning__table';

      const thead = document.createElement('thead');
      const headingRow = document.createElement('tr');
      columns.forEach((column) => {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = column == null ? '' : String(column);
        headingRow.appendChild(th);
      });
      thead.appendChild(headingRow);

      const tbody = document.createElement('tbody');
      rows.forEach((row) => {
        const tr = document.createElement('tr');
        const label = document.createElement('th');
        label.scope = 'row';
        label.textContent = row && row.label != null ? String(row.label) : '';
        tr.appendChild(label);

        const values = row && Array.isArray(row.values) ? row.values : [];
        for (let index = 0; index < columns.length - 1; index += 1) {
          const td = document.createElement('td');
          td.textContent = values[index] == null ? '' : String(values[index]);
          tr.appendChild(td);
        }
        tbody.appendChild(tr);
      });

      table.append(thead, tbody);
      scroll.appendChild(table);
      mount.replaceChildren(scroll);
      mount.dataset.chartReady = 'true';
    };

    const storageSeen = (key) => {
      try {
        return window.sessionStorage.getItem(key) === 'seen';
      } catch (error) {
        return false;
      }
    };

    const markStorageSeen = (key) => {
      try {
        window.sessionStorage.setItem(key, 'seen');
      } catch (error) {
        return;
      }
    };

    const initializeWarning = (section) => {
      if (section.dataset.warningReady === 'true') return;
      section.dataset.warningReady = 'true';

      const dialog = section.querySelector('[data-cats-pyjamas-dialog]');
      const openButton = section.querySelector('[data-cats-pyjamas-open]');
      const closeButton = section.querySelector('[data-cats-pyjamas-close]');
      const tabs = Array.from(section.querySelectorAll('[data-cats-pyjamas-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-cats-pyjamas-panel]'));
      if (!dialog) return;

      section.querySelectorAll('[data-cats-pyjamas-chart]').forEach(buildChart);

      const openDialog = () => {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      };

      const placeDetailNotice = () => {
        const detail = Array.from(document.querySelectorAll('.ndf-description p, .nfd-women-details__body p')).find((paragraph) => {
          const text = String(paragraph.textContent || '').toLowerCase();
          return text.includes('unsanforized') && text.includes('size up two');
        });

        if (
          !detail ||
          !openButton
        ) {
          return;
        }

        detail.classList.add('cats-pyjamas-warning__detail');

        if (detail.querySelector('[data-cats-pyjamas-detail-open]')) return;

        const detailCopyText = String(detail.textContent || '').replace(/\s+/g, ' ').trim();
        const emphasisEnd = detailCopyText.indexOf(':');
        const detailCopy = document.createElement('span');
        detailCopy.className = 'cats-pyjamas-warning__detail-copy';

        if (emphasisEnd >= 0) {
          const emphasis = document.createElement('strong');
          emphasis.className = 'cats-pyjamas-warning__detail-emphasis';
          emphasis.textContent = detailCopyText.slice(0, emphasisEnd + 1);
          detailCopy.append(emphasis, ` ${detailCopyText.slice(emphasisEnd + 1).trim()}`);
        } else {
          detailCopy.textContent = detailCopyText;
        }

        const detailButton = openButton.cloneNode(true);
        detailButton.removeAttribute('data-cats-pyjamas-open');
        detailButton.setAttribute('data-cats-pyjamas-detail-open', '');
        detailButton.className = 'cats-pyjamas-warning__open--detail';
        detailButton.textContent = openButton.textContent.trim();
        detailButton.addEventListener('click', openDialog);
        detail.replaceChildren(detailCopy, detailButton);
      };

      openButton?.addEventListener('click', openDialog);
      closeButton?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.catsPyjamasTab;
          tabs.forEach((candidate) => {
            const active = candidate === tab;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-selected', active ? 'true' : 'false');
            candidate.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.catsPyjamasPanel !== target;
          });
        });
        tab.addEventListener('keydown', (event) => {
          const index = tabs.indexOf(tab);
          let next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          next.click();
          next.focus();
        });
      });

      placeDetailNotice();

      const autoOpen = section.dataset.autoOpen === 'true';
      const oncePerSession = section.dataset.oncePerSession === 'true';
      const designMode = section.dataset.designMode === 'true';
      const storageKey = `nfd-cats-pyjamas-warning:${section.dataset.productId || 'product'}`;

      if (autoOpen && !designMode && (!oncePerSession || !storageSeen(storageKey))) {
        window.setTimeout(() => {
          openDialog();
          if (oncePerSession) markStorageSeen(storageKey);
        }, 350);
      }
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-cats-pyjamas-warning]').forEach(initializeWarning);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const section = event.target.querySelector('[data-cats-pyjamas-warning]');
      const dialog = section?.querySelector('[data-cats-pyjamas-dialog]');
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw26-men-collection"] && !Shopify.designMode) return;
  try {
    
  function initializeFW26MenIndex(root) {
    if (!root || root.dataset.indexInitialized === 'true') return;

    const index = root.querySelector('[data-fw26-index]');
    if (!index) return;

    root.dataset.indexInitialized = 'true';

    const cards = [...index.querySelectorAll('[data-fabric-card]')];
    const garmentButtons = [...index.querySelectorAll('[data-garment]')];
    const fitButtons = [...index.querySelectorAll('[data-fit]')];
    const minimumInput = index.querySelector('[data-weight-min]');
    const maximumInput = index.querySelector('[data-weight-max]');
    const range = index.querySelector('[data-weight-range]');
    const output = index.querySelector('[data-weight-output]');
    const reset = index.querySelector('[data-index-reset]');
    const status = index.querySelector('[data-index-status]');

    if (!minimumInput || !maximumInput || !range) return;

    const absoluteMinimum = Number(minimumInput.min);
    const absoluteMaximum = Number(maximumInput.max);
    const minimumGap = Number(minimumInput.step) || 0.25;
    let activeGarment = 'all';
    const activeFits = new Set();

    const formatWeight = (value) => {
      const numericValue = Number(value);
      const formatted = Number.isInteger(numericValue)
        ? String(numericValue)
        : String(Number(numericValue.toFixed(2)));
      return `${formatted}oz`;
    };

    const updateIndex = () => {
      const minimumWeight = Number(minimumInput.value);
      const maximumWeight = Number(maximumInput.value);
      const weightIsFiltered = minimumWeight > absoluteMinimum || maximumWeight < absoluteMaximum;
      let visibleCount = 0;

      cards.forEach((card) => {
        const garmentMatches = activeGarment === 'all' || card.dataset.garments.split(/\s+/).includes(activeGarment);
        const cardWeight = Number(card.dataset.weight);
        const hasWeight = card.dataset.weight !== '' && Number.isFinite(cardWeight);
        const weightMatches = weightIsFiltered
          ? hasWeight && cardWeight >= minimumWeight && cardWeight <= maximumWeight
          : true;
        const cardFits = (card.dataset.fits || '').split(/\s+/).filter(Boolean);
        const fitsMatch = [...activeFits].every((fit) => cardFits.includes(fit));
        const isVisible = garmentMatches && weightMatches && fitsMatch;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      const startPercent = ((minimumWeight - absoluteMinimum) / (absoluteMaximum - absoluteMinimum)) * 100;
      const endPercent = ((maximumWeight - absoluteMinimum) / (absoluteMaximum - absoluteMinimum)) * 100;
      range.style.setProperty('--range-start', `${startPercent}%`);
      range.style.setProperty('--range-end', `${endPercent}%`);

      if (output) {
        output.textContent = weightIsFiltered
          ? `${formatWeight(minimumWeight)} – ${formatWeight(maximumWeight)}`
          : root.dataset.allWeightsLabel;
      }

      if (status) {
        status.textContent = `${visibleCount} ${root.dataset.resultsLabel}`;
      }
    };

    garmentButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeGarment = button.dataset.garment;

        garmentButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });

        updateIndex();
      });
    });


    fitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const fit = button.dataset.fit;
        if (activeFits.has(fit)) activeFits.delete(fit);
        else activeFits.add(fit);

        fitButtons.forEach((item) => {
          const isActive = activeFits.has(item.dataset.fit);
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });

        updateIndex();
      });
    });

    minimumInput.addEventListener('input', () => {
      if (Number(minimumInput.value) > Number(maximumInput.value) - minimumGap) {
        minimumInput.value = String(Number(maximumInput.value) - minimumGap);
      }
      updateIndex();
    });

    maximumInput.addEventListener('input', () => {
      if (Number(maximumInput.value) < Number(minimumInput.value) + minimumGap) {
        maximumInput.value = String(Number(minimumInput.value) + minimumGap);
      }
      updateIndex();
    });

    if (reset) {
      reset.addEventListener('click', () => {
        activeGarment = 'all';
        activeFits.clear();
        minimumInput.value = String(absoluteMinimum);
        maximumInput.value = String(absoluteMaximum);

        garmentButtons.forEach((button) => {
          const isActive = button.dataset.garment === 'all';
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
        fitButtons.forEach((button) => {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });

        updateIndex();
      });
    }

    updateIndex();
  }

  document.querySelectorAll('[data-fw26-men]').forEach(initializeFW26MenIndex);
  document.addEventListener('shopify:section:load', (event) => {
    initializeFW26MenIndex(event.target.querySelector('[data-fw26-men]'));
  });

  } catch(e) { console.error(e); }
})();
})();
